import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/home/home.service';
import { AuthService } from 'src/auth/auth.service';
import { Chart, registerables } from 'chart.js';
import { RouterModule, Routes } from '@angular/router';
import { UsersService } from 'src/home/users/services/users.service';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  dashboardData: any = {};
  userInfo: any = {};
  isLoading: boolean = true;
  chart: Chart<'pie', number[], string> | undefined;
  userRole: string = '';
  userName: string = '';
  userRoleInfo: string = '';

  constructor(
    private homeService: HomeService,
    private authService: AuthService,
    private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.getDashboardData();
    this.getUserInfo();
  }

  getDashboardData() {
    this.homeService.getDashboardData().subscribe(
      (data) => {
        this.dashboardData = data;
        this.isLoading = false;
        setTimeout(() => this.createChart(), 0);
      },
      (error) => {
        console.error('Error fetching dashboard data:', error);
        this.isLoading = false;
      }
    );
  }

  getUserInfo() {
    this.userRole = this.authService.getCurrentUserRole();
    this.userName = localStorage.getItem('email') || '';
    this.userRoleInfo = localStorage.getItem('userRole') || ''
  }

  createChart() {
    if (this.chart) {
      this.chart.destroy();
    }

    const ctx = document.getElementById('otherDataChart') as HTMLCanvasElement;

    if (!ctx) {
      console.error('Failed to find canvas element for chart');
      return;
    }

    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: ['Activos', 'Inactivos', 'Inactivos por Intentos'],
        datasets: [
          {
            data: [
              this.dashboardData.activeProviders || 0,
              this.dashboardData.inactiveProviders || 0,
              this.dashboardData.inactiveForAttemptsProviders || 0,
            ],
            backgroundColor: ['#4CAF50', '#F44336', '#FFC107'],
            hoverBackgroundColor: ['#66BB6A', '#E57373', '#FFB74D'],
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
          },
        },
      },
    });
  }
}
